<div class="page">
  <app-page-header itemName="{{ property.get('name') }}" page-title="properties.detail.viewPageTitle">
  </app-page-header>
  <div class="page-content">

    <div class="alert alert-danger text-center mb-4" *ngIf="propertyData && !propertyData.active">
      {{ 'properties.detail.suspended_property_alert' | translate }}
    </div>
    
    <!-- STRUCTURE CARD -->
    <mat-card class="custom-card mt-4" id="structure-card"
      *ngIf="currentRole.propertiesPermission && currentRole.propertiesPermission.mappatura && !condoStructureOpen">
      <mat-card-title>{{ 'properties.detail.mappingTab.title' | translate }}
      </mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>

          <div class="row">
            <app-card-spinner [visible]="structureIsLoading" type="zero"></app-card-spinner>
            <div class="side-menu col-12 col-md-5 col-lg-4">
              <ng-container *ngIf="mappingIndex && mappingIndex.length">
                <mat-accordion class="mapping-index">
                  <ng-container *ngFor="let item of mappingIndex; let i = index;">

                    <div class="custom-expansion-panel" [ngClass]="{'openFirstLevel': item.expanded === true}">
                      <!-- Icon and title accordion -->
                      <a href="javascript:;" class="header-link-wrapper" (click)="onPanelClicked(item, i)">
                        <div class="custom-expansion-panel-header">
                          <div class="custom-expansion-panel-toggle"
                            [ngClass]="{'openFirstLevel': item.expanded === true}">
                          </div>
                          <div class="custom-expansion-panel-header-content">
                            <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon === ''">
                              <mat-icon fontSet="fal" fontIcon="fa-folder" class="mr-3 fa-fw"
                                [ngClass]="{'d-none': item.expanded === true}"></mat-icon>
                              <mat-icon fontSet="fal" fontIcon="fa-folder-open" class="mr-3 fa-fw"
                                [ngClass]="{'d-none': item.expanded === false}"></mat-icon>
                            </div>
                            <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon !== ''">
                              <div *ngIf="item.title !== 'properties.structures.amianto'">
                                <mat-icon fontSet="fal" fontIcon="{{ item.icon }}" class="mr-3 fa-fw"></mat-icon>
                              </div>
                              <div *ngIf="item.title === 'properties.structures.amianto'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="54px" height="54px">
                                  <text font-weight="50" fill="#ec9451" x="19" y="34" font-size="37">a</text>
                                </svg>
                              </div>
                            </div>
                            <strong>{{ item.title | translate  }}</strong>
                          </div>
                        </div>
                      </a>

                      <div class="custom-expansion-panel-content">
                        <div *ngIf="item.content.length">
                          <div *ngFor="let subItem of item.content">

                            <ng-container *ngIf="subItem.key === 'anagrafica'">
                              <div class="element no-children-element" [ngClass]="{'active': subItem.active}">
                                <a (click)="activateSection(subItem.section)">
                                  <span>{{ subItem.title | translate }}</span>
                                </a>
                              </div>
                            </ng-container>

                            <ng-container
                              *ngIf="!subItem.hidden && subItem.type === 'link' && subItem.key !== 'anagrafica'">
                              <div matBadge="{{ getChildren(subItem.key).length }}" matBadgePosition="above after"
                                matBadgeColor="primary" *ngIf="subItem.key !== 'anagrafica'">
                              </div>
                              <div class="custom-expansion-panel-child" *ngIf="getChildren(subItem.key).length">
                                <a href="javascript:;" class="header-link-wrapper"
                                  (click)="subItem.expanded = !subItem.expanded">
                                  <div class="custom-expansion-panel-header-second">
                                    <div class="custom-expansion-panel-toggle-child"
                                      [ngClass]="{'openSecondLevel': subItem.expanded === true}"></div>
                                    <div class="custom-expansion-panel-header-content-second">
                                      <span>{{ subItem.title | translate  }}</span>
                                    </div>
                                  </div>
                                </a>

                                <ul class="custom-expansion-panel-content-list"
                                  [ngClass]="{'openSecondLevel': subItem.expanded === true}">
                                  <li *ngFor="let subSubitem of getChildren(subItem.key)"
                                    [ngClass]="{'active': (model._id === subSubitem._id && subSubitem.active)}"
                                    class="element">
                                    <a *ngIf="subSubitem.active" (click)="onFormItemClick(subItem.section, subSubitem)">
                                      <span *ngIf="subItem.key === 'dipendenti'">{{ subSubitem.nome }}
                                        {{ subSubitem.cognome }} </span>
                                      <span *ngIf="subItem.key === 'impresePulizia'">{{ subSubitem.nomeDitta }}</span>
                                      <!-- <span
                                        *ngIf="subItem.key === 'estintori'">{{ 'properties.structures.estintori' | translate }}</span> -->
                                      <span
                                        *ngIf="subItem.key === 'amianto'">{{ 'properties.structures.amianto' | translate }}</span>
                                      <!-- <span
                                        *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia' && subItem.key !== 'estintori'">{{ subSubitem.nome }}</span> -->
                                      <span
                                        *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia'">{{ subSubitem.nome }}</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>

                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>

                  </ng-container>

                  <!-- <ng-container *ngFor="let item of mappingIndex; let i = index;">
                    <mat-expansion-panel class="my-0 main-panel" [disabled]="item.disabled" [expanded]="item.expanded"
                      *ngIf="checkVisibility(item)" (opened)="onItemOpen(item)" (closed)="onItemClose(item)">
                      <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                        <mat-panel-title title="{{ item.disabled ? item.disabledTitle : '' }}"
                          class="fs-10 align-items-center">
                          <ng-container *ngIf="item.icon === ''">
                            <mat-icon fontSet="fal" fontIcon="fa-folder" class="mr-3 fa-fw"
                              [ngClass]="{'d-none': item.expanded === true}"></mat-icon>
                            <mat-icon fontSet="fal" fontIcon="fa-folder-open" class="mr-3 fa-fw"
                              [ngClass]="{'d-none': item.expanded === false}"></mat-icon>
                          </ng-container>
                          <ng-container *ngIf="item.icon !== ''">
                            <div *ngIf="item.title !== 'properties.structures.amianto'">
                              <mat-icon fontSet="fal" fontIcon="{{ item.icon }}" class="mr-3 fa-fw"></mat-icon>
                            </div>
                            <div *ngIf="item.title === 'properties.structures.amianto'">
                              <svg xmlns="http://www.w3.org/2000/svg" width="54px" height="54px">
                                <text font-weight="50" fill="#ec9451" x="19" y="34" font-size="37">a</text>
                              </svg>
                            </div>
                          </ng-container>
                          <strong>{{ item.title | translate  }}</strong>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div *ngIf="item.content.length">
                        <div *ngFor="let subItem of item.content">
                          <ng-container *ngIf="subItem.type === 'link' &&
                                (getCounter(subItem.key)
                                || subItem.key === 'anagrafica')">
                            <div matBadge="{{ getCounter(subItem.key) }}" matBadgePosition="above after"
                              matBadgeColor="primary" *ngIf="subItem.key !== 'anagrafica'">

                              <mat-expansion-panel class="my-0 sub-panel" [disabled]="subItem.disabled"
                                [expanded]="subItem.expanded" (opened)="onItemOpen(subItem)"
                                (closed)="onItemClose(subItem)" (afterExpand)="afterExpandHandler()">
                                <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                                  <mat-panel-title title="{{ subItem.disabled ? subItem.disabledTitle : '' }}"
                                    class="fs-10 align-items-center pl-5">
                                    {{ subItem.title | translate  }}
                                  </mat-panel-title>
                                </mat-expansion-panel-header>

                                <div class="subitem-values" #panelContainer>
                                  <div *ngFor="let subSubitem of getChildren(subItem.key)"
                                    [ngClass]="{'active': (model?._id === subSubitem._id && subSubitem.active)}"
                                    class="element">
                                    <a (click)="onFormItemClick(subItem.section, subSubitem)">
                                      <mat-icon fontSet="fal" fontIcon="fa-minus-circle" *ngIf="!subSubitem.active">
                                      </mat-icon>
                                      <span *ngIf="subItem.key === 'dipendenti'">{{ subSubitem.nome }}
                                        {{ subSubitem.cognome }} </span>
                                      <span *ngIf="subItem.key === 'impresePulizia'">{{ subSubitem.nomeDitta }}</span>
                                      <span
                                        *ngIf="subItem.key === 'estintori'">{{ 'properties.structures.estintori' | translate }}</span>
                                      <span
                                        *ngIf="subItem.key === 'amianto'">{{ 'properties.structures.amianto' | translate }}</span>
                                      <span
                                        *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia' && subItem.key !== 'estintori'">{{ subSubitem.nome }}</span>
                                    </a>
                                  </div>
                                </div>
                              </mat-expansion-panel>
                            </div>

                            <div *ngIf="subItem.key === 'anagrafica'" class="subitem-values">
                              <div class="element">
                                <a (click)="activateSection(subItem.section)">
                                  <span>{{ subItem.title | translate }}</span>
                                </a>
                              </div>
                            </div>

                          </ng-container>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </ng-container> -->
                </mat-accordion>
              </ng-container>
            </div>


            <div class="col-12 col-md-7 col-lg-8" [ngClass]="{ 'side-form-loading': formIsLoading }">
              <app-card-spinner [visible]="formIsLoading" type="zero"></app-card-spinner>
              <div class="alert alert-info" *ngIf="!formActiveSection">
                <strong>{{ 'properties.structures.warning' | translate }}</strong> <br>
                <p class="mb-0">
                  {{ 'properties.structures.selectElem' | translate }}
                </p>
              </div>

              <div *ngIf="formActiveSection && formActiveSubitemId">
                <div class="row">
                  <div class="col-10">
                    <h4>
                      {{ activeItem?.title | translate }} {{ model?.nome ? '- ' + model.nome : '' }}
                    </h4>
                  </div>
                </div>

                <hr>

                <div class="form-wrapper mt-3 py-3" *ngIf="!formIsLoading">
                  <form [formGroup]="form">
                    <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- DOCUMENTS CARD -->
    <mat-card class="custom-card mt-4" *ngIf="displayedDocs.length > 0">
      <mat-card-title>{{ 'properties.detail.documentArchive.title' | translate }}
      </mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12 col-md-5 col-lg-4 archive-side-menu">
              <!-- Side menu -->
              <div class="side-menu">
                <ng-container *ngIf="documentsStructure.length">
                  <mat-accordion class="documents-index">
                    <ng-container *ngFor="let item of documentsStructure; let i = index;">

                      <ng-container [ngTemplateOutlet]="sideMenuTemplate" [ngTemplateOutletContext]="{item:item}"
                        *ngIf="item.visible">
                      </ng-container>

                    </ng-container>
                  </mat-accordion>
                </ng-container>
              </div>
              <!-- /Side menu -->
              <!-- Legend
              <div class="mt-4" *ngIf="!documentArchiveIsLoading">
                <div class="legend-title">
                  {{ 'properties.documents.legend.title' | translate }}
                </div>
                <div class="legend-item">
                  <mat-chip selected class="mat-chip-sm chip-green"></mat-chip>
                  {{ 'properties.documents.legend.inserted' | translate }}
                </div>
                <div class="legend-item">
                  <mat-chip selected class="mat-chip-sm chip-red"></mat-chip>
                  {{ 'properties.documents.legend.missing' | translate }}
                </div>
                <div class="legend-item">
                  <mat-chip selected class="mat-chip-sm chip-black"></mat-chip>
                  {{ 'properties.documents.legend.not_mandatory' | translate }}
                </div>
                <div class="legend-item">
                  <mat-icon fontSet="fas" fontIcon="fa-history"></mat-icon>
                  {{ 'properties.documents.legend.expired' | translate }}
                </div>
              </div>
               /Legend -->
            </div>

            <!-- List of all documents -->
            <div class="col-12 col-md-7 col-lg-8" style="height: 800px; overflow-y: auto;" id="doc-wrapper">
              <app-card-spinner [visible]="documentArchiveIsLoading" type="zero"></app-card-spinner>

              <ng-container *ngFor="let item of displayedDocs | keyvalue: originalOrder; let i = index">
                <div class="document-wrapper">
                  <div class="document-wrapper title">
                    {{ i + 1 }} {{ item.value.title?.toUpperCase() }}
                  </div>
                  <div *ngIf="item.value.type === 'title'">
                    <div *ngFor="let docItem of item.value.content | keyvalue: originalOrder; let t = index">
                      <div class="d-flex document-wrapper subtitle" id="{{ docItem.value.title }}" #scrollTarget>
                        <div>
                          {{ i + 1 }}.{{ t + 1 }} {{ docItem.value.title }}
                        </div>
                        <button class="add-icon-button" colo="primary" (click)="onForbiddenInsertDocDialog()"
                          mat-icon-button matTooltip="{{ 'common.cta.addNew' | translate }}" matTooltipPosition="right"
                          *ngIf="editDocument">
                          <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
                        </button>
                        <button class="add-icon-button" colo="primary" (click)="onInsertDocDialogOpen(docItem.value)"
                          mat-icon-button matTooltip="{{ 'common.cta.addNew' | translate }}" matTooltipPosition="right"
                          *ngIf="editDocument">
                          <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
                        </button>
                      </div>
                      <div *ngIf="docItem.value.type === 'title'">
                        <div *ngFor="let subDocItem of docItem.value.content | keyvalue: originalOrder; let x = index">
                          <div class="document-wrapper subsubtitle">
                            <div id="{{ subDocItem.value.title }}" #scrollTarget>
                              {{ i + 1 }}.{{ t + 1 }}.{{ x + 1 }} {{ subDocItem.value.title }}
                            </div>
                          </div>
                          <div *ngIf="subDocItem.value.content.length">
                            <table class="table table-borderless table-striped table-hover-ext-ext" matSort
                              (matSortChange)="sortData($event, i, t, x, '1')">
                              <thead>
                                <th class="clickable col-fixed-md" mat-sort-header="title">
                                  {{ 'properties.documentsPage.docType' | translate }}</th>
                                <th class="clickable col-fixed-sm" mat-sort-header="data.contenutoDocumento">
                                  {{ 'properties.documentsPage.descr' | translate }}</th>
                                <th class="clickable col-fixed-xs" mat-sort-header="data.ragioneSocialeFornitore">
                                  {{ 'properties.documentsPage.supplier' | translate }}</th>
                                <th class="clickable col-fixed-xs" mat-sort-header="data.dataDocumento">
                                  {{ 'properties.documentsPage.date' | translate }}</th>
                                <th class="clickable col-fixed-xs" mat-sort-header="dateExpired">
                                  {{ 'properties.documentsPage.expiredDate' | translate }}</th>
                                <th class="col-fixed-xxs text-center">Azioni</th>
                              </thead>
                              <tbody>
                                <tr *ngFor="let subSubDocItem of subDocItem.value.content | keyvalue: originalOrder"
                                  [ngClass]="{'document-wrapper-text-mandatory-added': subSubDocItem.value.mandatory && !subSubDocItem.value.expired && helperService.isDocumentDataPopulated(subSubDocItem.value.data),
                                    'document-wrapper-text-mandatory-missing': subSubDocItem.value.mandatory && !subSubDocItem.value.expired && !helperService.isDocumentDataPopulated(subSubDocItem.value.data),
                                    'document-wrapper-text-not-mandatory': !subSubDocItem.value.mandatory || subSubDocItem.value.expired}">
                                  <!-- TIPO -->
                                  <td class="col-fixed-md document-wrapper-text">
                                    {{ subSubDocItem.value.title }}
                                    <div *ngIf="subSubDocItem.value.expired" class="document-expired">
                                      {{ (subSubDocItem.value.privacy ? 'properties.documentsPage.tagSuperato' : 'properties.documentsPage.tagExpired') | translate }}</div>
                                  </td>
                                  <!-- DESCRIZIONE -->
                                  <td class="col-fixed-sm document-wrapper-text">
                                    {{ subSubDocItem.value.data ? subSubDocItem.value.data.contenutoDocumento : '_____' }}
                                  </td>
                                  <!-- NOME ESECUTORE -->
                                  <td class="col-fixed-xs document-wrapper-text">
                                    {{ (subSubDocItem.value.data && subSubDocItem.value.data.ragioneSocialeFornitore)  ? subSubDocItem.value.data.ragioneSocialeFornitore : '_____' }}
                                  </td>
                                  <!-- DATA -->
                                  <td class="document-wrapper-text">
                                    {{ subSubDocItem.value.data && subSubDocItem.value.data.dataDocumento ? (subSubDocItem.value.data.dataDocumento | dateDocumentFormat) : (subSubDocItem.value.data && subSubDocItem.value.data.dataDocumentochkNA ? ('properties.detail.documentArchive.notAvailable' | translate) : '_____') }}
                                  </td>
                                  <!-- DATA SCADENZA -->
                                  <td class="document-wrapper-text">
                                    {{ subSubDocItem.value.dateExpired ? (subSubDocItem.value.dateExpired | date) : '_____' }}
                                  </td>
                                  <!-- AZIONI -->
                                  <td class="row-archive">
                                    <div
                                      *ngIf="subSubDocItem.value.data">
                                      <div
                                        *ngIf="!(subDocItem.value.active && editDocument && !subSubDocItem.value.data && loggedUserPermissions.includes('canEditDocumentsData'))">
                                        <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                                          <mat-icon fontSet="fas" fontIcon="fa-ellipsis-v"></mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">

                                          <button mat-menu-item *ngIf="subSubDocItem.value.data"
                                            (click)="onToggleDownloadDocument(subSubDocItem.value.data.document)">
                                            <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
                                            </mat-icon>
                                            {{ 'common.cta.downloadFile' | translate }}
                                          </button>
                                        </mat-menu>
                                      </div>
                                    </div>

                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="docItem.value.type === 'contract'">
                        <div *ngFor="let subDocItem of docItem.value.content | keyvalue: originalOrder; let x = index">

                          <div *ngIf="subDocItem.value.content.length" id="{{ subDocItem.value.title }}" #scrollTarget>
                            <table class="table table-borderless table-striped table-hover-ext" matSort
                              (matSortChange)="sortData($event, i, t, x, '1')">
                              <thead>
                                <th class="clickable col-fixed-md" mat-sort-header="title">
                                  {{ 'properties.documentsPage.docType' | translate }}</th>
                                <th class="clickable col-fixed-sm" mat-sort-header="data.contenutoDocumento">
                                  {{ 'properties.documentsPage.descr' | translate }}</th>
                                <th class="clickable col-fixed-xs" mat-sort-header="data.ragioneSocialeFornitore">
                                  {{ 'properties.documentsPage.supplier' | translate }}</th>
                                <th class="clickable col-fixed-xs" mat-sort-header="data.dataDocumento">
                                  {{ 'properties.documentsPage.date' | translate }}</th>
                                <th class="clickable col-fixed-xs" mat-sort-header="dateExpired">
                                  {{ 'properties.documentsPage.expiredDate' | translate }}</th>
                                <th class="col-fixed-xxs text-center">Azioni</th>
                              </thead>
                              <tbody>
                                <tr *ngFor="let subSubDocItem of subDocItem.value.content | keyvalue: originalOrder"
                                  [ngClass]="{'document-wrapper-text-mandatory-added': subSubDocItem.value.mandatory && !subSubDocItem.value.expired && helperService.isDocumentDataPopulated(subSubDocItem.value.data),
                                    'document-wrapper-text-mandatory-missing': subSubDocItem.value.mandatory && !subSubDocItem.value.expired && !helperService.isDocumentDataPopulated(subSubDocItem.value.data),
                                    'document-wrapper-text-not-mandatory': !subSubDocItem.value.mandatory || subSubDocItem.value.expired}">
                                  <!-- STATO -->
                                  <!-- TIPO -->
                                  <td class="col-fixed-md document-wrapper-text">
                                    {{ subSubDocItem.value.title }}
                                    <strong
                                      *ngIf="subSubDocItem.value.structureTitle !=''">({{ subSubDocItem.value.structureTitle }})</strong>
                                    <div *ngIf="subSubDocItem.value.expired" class="document-expired">
                                      {{ (subSubDocItem.value.privacy ? 'properties.documentsPage.tagSuperato' : 'properties.documentsPage.tagExpired') | translate }}</div>
                                  </td>
                                  <!-- DESCRIZIONE -->
                                  <td class="col-fixed-sm document-wrapper-text">
                                    {{ subSubDocItem.value.data ? subSubDocItem.value.data.contenutoDocumento : '_____' }}
                                  </td>
                                  <!-- NOME ESECUTORE -->
                                  <td class="col-fixed-xs document-wrapper-text">
                                    {{ (subSubDocItem.value.data && subSubDocItem.value.data.ragioneSocialeFornitore)  ? subSubDocItem.value.data.ragioneSocialeFornitore : '_____' }}
                                  </td>
                                  <!-- DATA -->
                                  <td class="document-wrapper-text">
                                    {{ subSubDocItem.value.data && subSubDocItem.value.data.dataDocumento ? (subSubDocItem.value.data.dataDocumento | dateDocumentFormat) : (subSubDocItem.value.data && subSubDocItem.value.data.dataDocumentochkNA ? ('properties.detail.documentArchive.notAvailable' | translate) : '_____') }}
                                  </td>
                                  <!-- DATA SCADENZA -->
                                  <td class="document-wrapper-text">
                                    {{ subSubDocItem.value.dateExpired ? (subSubDocItem.value.dateExpired | date) : '_____' }}
                                  </td>
                                  <!-- AZIONI -->
                                  <td class="row-archive">
                                    <div
                                      *ngIf="subSubDocItem.value.data">
                                      <div
                                        *ngIf="!(subSubDocItem.value.active && editDocument && !subSubDocItem.value.data && loggedUserPermissions.includes('canEditDocumentsData'))">
                                        <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                                          <mat-icon fontSet="fas" fontIcon="fa-ellipsis-v"></mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">

                                          <button mat-menu-item *ngIf="subSubDocItem.value.data"
                                            (click)="onToggleDownloadDocument(subSubDocItem.value.data.document)">
                                            <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
                                            </mat-icon>
                                            {{ 'common.cta.downloadFile' | translate }}
                                          </button>
                                        </mat-menu>
                                      </div>
                                    </div>

                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="docItem.value.type === 'doc'">
                        <table class="table table-borderless table-striped table-hover-ext" matSort
                          (matSortChange)="sortData($event, i, t, '', '2')">
                          <thead>
                            <th class="clickable col-fixed-md" mat-sort-header="title">
                              {{ 'properties.documentsPage.docType' | translate }}</th>
                            <th class="clickable col-fixed-sm" mat-sort-header="data.contenutoDocumento">
                              {{ 'properties.documentsPage.descr' | translate }}
                            </th>
                            <th class="clickable col-fixed-xs" mat-sort-header="data.ragioneSocialeFornitore">
                              {{ 'properties.documentsPage.supplier' | translate }}</th>
                            <th class="clickable col-fixed-xs" mat-sort-header="data.dataDocumento">
                              {{ 'properties.documentsPage.date' | translate }}</th>
                            <th class="clickable col-fixed-xs" mat-sort-header="dateExpired">
                              {{ 'properties.documentsPage.expiredDate' | translate }}</th>
                            <th class="col-fixed-xxs text-center">Azioni</th>
                          </thead>
                          <tbody>
                            <tr *ngFor="let subDocItem of docItem.value.content | keyvalue: originalOrder" [ngClass]="{'document-wrapper-text-mandatory-added': subDocItem.value.mandatory && !subDocItem.value.expired && helperService.isDocumentDataPopulated(subDocItem.value.data),
                                    'document-wrapper-text-mandatory-missing': subDocItem.value.mandatory && !subDocItem.value.expired && !helperService.isDocumentDataPopulated(subDocItem.value.data),
                                    'document-wrapper-text-not-mandatory': !subDocItem.value.mandatory || subDocItem.value.expired}">
                              <td class="col-fixed-md document-wrapper-text">
                                {{ subDocItem.value.title }}
                                <div *ngIf="subDocItem.value.expired" class="document-expired">
                                  {{ (subDocItem.value.privacy ? 'properties.documentsPage.tagSuperato' : 'properties.documentsPage.tagExpired') | translate }}</div>
                              </td>
                              <td class="col-fixed-sm document-wrapper-text">
                                {{ subDocItem.value.data ? subDocItem.value.data.contenutoDocumento : '_____' }}
                              </td>
                              <td class="col-fixed-xs document-wrapper-text">
                                {{ (subDocItem.value.data && subDocItem.value.data.ragioneSocialeFornitore)  ? subDocItem.value.data.ragioneSocialeFornitore : '_____' }}
                              </td>
                              <td class="document-wrapper-text">
                                {{ subDocItem.value.data && subDocItem.value.data.dataDocumento ? (subDocItem.value.data.dataDocumento | dateDocumentFormat) : (subDocItem.value.data && subDocItem.value.data.dataDocumentochkNA ? ('properties.detail.documentArchive.notAvailable' | translate) : '_____') }}
                              </td>
                              <td class="document-wrapper-text">
                                {{ subDocItem.value.dateExpired ? (subDocItem.value.dateExpired | date) : '_____' }}
                              </td>
                              <td class="row-archive">
                                <div
                                  *ngIf="subDocItem.value.data">
                                  <div
                                    *ngIf="!(editDocument && !subDocItem.value.data && loggedUserPermissions.includes('canEditDocumentsData'))">
                                    <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                                      <mat-icon fontSet="fas" fontIcon="fa-ellipsis-v"></mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                      <button mat-menu-item *ngIf="subDocItem.value.data"
                                        (click)="onToggleDownloadDocument(subDocItem.value.data.document)">
                                        <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action"></mat-icon>
                                        {{ 'common.cta.downloadFile' | translate }}
                                      </button>

                                    </mat-menu>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="item.value.type === 'doc'">
                    <table class="table table-borderless table-striped table-hover-ext" matSort
                      (matSortChange)="sortData($event, i, '', '', '3')">
                      <thead>
                        <th class="clickable col-fixed-md" mat-sort-header="title">
                          {{ 'properties.documentsPage.docType' | translate }}</th>
                        <th class="clickable col-fixed-sm" mat-sort-header="data.contenutoDocumento">
                          {{ 'properties.documentsPage.descr' | translate }}</th>
                        <th class="clickable col-fixed-xs" mat-sort-header="data.ragioneSocialeFornitore">
                          {{ 'properties.documentsPage.supplier' | translate }}</th>
                        <th class="clickable col-fixed-xs" mat-sort-header="data.dataDocumento">
                          {{ 'properties.documentsPage.date' | translate }}</th>
                        <th class="clickable col-fixed-xs" mat-sort-header="dateExpired">
                          {{ 'properties.documentsPage.expiredDate' | translate }}</th>
                        <th class="col-fixed-xxs text-center">Azioni</th>
                      </thead>
                      <tbody>
                        <tr *ngFor="let subDocItem of item.value.content | keyvalue: originalOrder" [ngClass]="{'document-wrapper-text-mandatory-added': subDocItem.value.mandatory && !subDocItem.value.expired && helperService.isDocumentDataPopulated(subDocItem.value.data),
                                    'document-wrapper-text-mandatory-missing': subDocItem.value.mandatory && !subDocItem.value.expired && !helperService.isDocumentDataPopulated(subDocItem.value.data),
                                    'document-wrapper-text-not-mandatory': !subDocItem.value.mandatory || subDocItem.value.expired}">
                          <td class="col-fixed-md">
                            {{ subDocItem.value.title }}
                            <div *ngIf="subDocItem.value.expired" class="document-expired">
                              {{ (subDocItem.value.privacy ? 'properties.documentsPage.tagSuperato' : 'properties.documentsPage.tagExpired') | translate }}</div>
                          </td>
                          <td class="col-fixed-sm">
                            {{ subDocItem.value.data ? subDocItem.value.data.contenutoDocumento : '_____' }}
                          </td>
                          <td class="col-fixed-xs">
                            {{ (subDocItem.value.data && subDocItem.value.data.ragioneSocialeFornitore)  ? subDocItem.value.data.ragioneSocialeFornitore : '_____' }}
                          </td>
                          <td>
                            {{ subDocItem.value.data && subDocItem.value.data.dataDocumento ? (subDocItem.value.data.dataDocumento | dateDocumentFormat) : (subDocItem.value.data && subDocItem.value.data.dataDocumentochkNA ? ('properties.detail.documentArchive.notAvailable' | translate) : '_____') }}
                          </td>
                          <td>
                            {{ subDocItem.value.dateExpired ? (subDocItem.value.dateExpired | date) : '_____' }}
                          </td>
                          <td class="row-archive">
                            <div
                              *ngIf="subDocItem.value.data">
                              <div
                                *ngIf="!(editDocument && !subDocItem.value.data && loggedUserPermissions.includes('canEditDocumentsData'))">
                                <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                                  <mat-icon fontSet="fas" fontIcon="fa-ellipsis-v"></mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">

                                  <button mat-menu-item *ngIf="subDocItem.value.data"
                                    (click)="onToggleDownloadDocument(subDocItem.value.data.document)">
                                    <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action"></mat-icon>
                                    {{ 'common.cta.downloadFile' | translate }}
                                  </button>

                                </mat-menu>
                              </div>
                            </div>

                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-container>
            </div>
            <!-- /List of all documents -->
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->

<!-- Template Side menu -->
<ng-template #sideMenuTemplate let-item="item" let-subpanel="subpanel" let-height="height">
  <mat-expansion-panel class="my-0 main-panel" [expanded]="item.expanded" (opened)="onItemOpen(item)"
    (closed)="onItemClose(item)" [ngClass]="{'subpanel': subpanel}">
    <mat-expansion-panel-header [collapsedHeight]="height ? height + 'px' : '40px'"
      [expandedHeight]="height ? height + 'px' : '40px'" (opened)="item.onOpen()">
      <mat-panel-title class="ml-3 fs-10 align-items-center menu-panel-title">
        <span *ngIf="lang === 'it'">{{ item.translation.it }}</span>
        <span *ngIf="lang === 'en'">{{ item.translation.en }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="px-3" *ngIf="item.content && item.content.length" class="expanded">
      <ng-container *ngFor="let subItem of item.content">

        <ng-container *ngIf="subItem.type === 'link' && subItem.visible">
          <button mat-stroked-button title="{{ subItem.buttonTitle | translate  }}" class="btn-block btn-menu-level2"
            (click)="onTitleClicked(subItem.translation.it)">
            <!-- <div matBadge="{{ subItem.notInsert }}" matBadgePosition="above after" class="badge-status-mandatory"></div>
            <div matBadge="{{ subItem.mandatory }}" matBadgePosition="above after" class="badge-status-mandatory-added">
            </div>
            <div matBadge="{{ subItem.optional }}" matBadgePosition="above after" class="badge-status-not-mandatory">
            </div> -->
            <div class="text-wrapper">
              <span *ngIf="!subItem.translation">{{ subItem.title }}</span>
              <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
              <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
            </div>
          </button>
        </ng-container>

        <ng-container *ngIf="subItem.type === 'accordion'">
          <ng-container [ngTemplateOutlet]="sideMenuTemplate"
            [ngTemplateOutletContext]="{item:subItem, subpanel: true, height: 35}">
          </ng-container>
        </ng-container>

      </ng-container>
    </div>
  </mat-expansion-panel>
</ng-template>
<!-- /Template Side menu -->